import React from "react";
import createSvgIcon from "@material-ui/icons/utils/createSvgIcon";

export default createSvgIcon(
  <React.Fragment>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.34919 3.36456C5.48938 3.13793 5.73688 3 6.00337 3H18.1314C18.403 3 18.6546 3.14329 18.7931 3.37697L21.8925 8.60523C22.0532 8.87635 22.0323 9.21809 21.8397 9.46757L12.811 21.1624C12.6671 21.3488 12.4458 21.459 12.2103 21.4615C11.9749 21.464 11.7512 21.3585 11.6034 21.1752L2.1705 9.48043C1.96552 9.22631 1.9433 8.87048 2.11505 8.59283L5.34919 3.36456ZM5.82524 5.51942L6.81746 8.22827H4.14958L5.82524 5.51942ZM4.37796 9.76673L9.87925 16.5872L7.38099 9.76673H4.37796ZM9.01941 9.76673L12.186 18.4119L15.215 9.76673H9.01941ZM16.8451 9.76673L14.502 16.4545L19.6651 9.76673H16.8451ZM19.8805 8.22827H17.3842L18.3115 5.58152L19.8805 8.22827ZM17.0468 4.53846H13.6797L16.0297 7.44148L17.0468 4.53846ZM14.6872 8.22827L12.0733 4.99919L9.51088 8.22827H14.6872ZM8.16881 7.44452L10.4749 4.53846H7.10434L8.16881 7.44452Z"
    />
  </React.Fragment>,
  `Cliparts`
);
